const GET_LIST = "getList";
const GET_MANY = "getMany";
const GET_ONE = "getOne";
const CREATE = "create";
const UPDATE = "update";
const UPDATE_MANY = "updateMany";
const DELETE = "delete";
const DELETE_MANY = "deleteMany";
// const GET_TREE = "getTree";
// const GET_NODES = "getNodes";
// const MOVE_NODE = "moveNode";
const CUSTOM_HTTP_CALL = "customHttpCall";

import FetchHydra from "@/@core/providers/fetch/fetchHydra";
import qs from "qs";

export default httpClient => {
  if (typeof httpClient === "string") {
    httpClient = new FetchHydra(httpClient);
  }

  return {
    [CUSTOM_HTTP_CALL]: (method, url, params) => {
      const PATCH_OPTIONS = { "Content-Type": "application/merge-patch+json" };
      switch (method.toLowerCase()) {
        case "post":
          return httpClient.post(url, params);
        case "get":
          return httpClient.get(url);
        case "put":
          return httpClient.put(url, params);
        case "delete":
          return httpClient.delete(url);
        case "patch":
          return httpClient.patch(url, params, PATCH_OPTIONS);
        default:
          return Promise.reject();
      }
    },
    [GET_LIST]: (resource, params) => {
      const { pagination, sort, filter, disablePagination } = params;
      let query = filter || {};

      if (!disablePagination) {
        query = {
          ...query,
          page: pagination.page,
          itemsPerPage: pagination.perPage,
        };
      } else {
        query = {
          ...query,
          pagination: false,
        };
      }

      if (sort && sort.length) {
        query.order = {};

        sort.forEach(item => {
          let { by, desc } = item;

          query.order[by] = desc ? "desc" : "asc";
        });
      } else {
        // By default (If no other sorting is set), order by updatedAt, DESC.
        query.order = { updatedAt: "desc" };
      }

      if (query.deleted === true) {
        query.exists = { deletedAt: true };
      }

      return httpClient.get(`${resource}?${qs.stringify(query, { arrayFormat: "brackets" })}`);
    },
    [GET_MANY]: (resource, params) => {
      /**
       * The reason for the following condition is the way vuetify-admin autocomplete input works.
       * When using va-autocomplete, we might have values that have to be pre-selected. The way
       * va-autocomplete will resolve those values and pre-select them, is by sending a GET_MANY request
       * with IDs passed as function parameters. If we didn't have this condition, va-autocomplete would
       * automatically fetch ALL THE ITEMS from provided 'resource' prop ON PAGE LOAD, and we would break
       * the whole point of having an autocomplete.
       */
      if (params && params.ids) {
        return Promise.all(
          params.ids.map(id => httpClient.get(`${resource}/${id.substring(id.lastIndexOf("/") + 1)}`)),
        ).then(responses => ({
          data: responses.map(({ data }) => data),
        }));
      }

      return httpClient.get(resource);
    },
    [GET_ONE]: (resource, params) => httpClient.get(`${resource}/${params.id}`),
    [CREATE]: (resource, params) => httpClient.post(resource, params.data),
    [UPDATE]: (resource, params) => {
      // When editing a page, we have to send PATCH so that page publish flow is not triggered (LAN-2461)
      if (resource === "pages") {
        return httpClient.patch(`${resource}/${params.id}`, params.data);
      }

      return httpClient.put(`${resource}/${params.id}`, params.data);
    },
    [UPDATE_MANY]: (resource, params) => {
      let resourcePath = params.customEndPoint ? params.customEndPoint : resource;

      return httpClient.put(`${resourcePath}`, params);
    },
    [DELETE]: (resource, params) => httpClient.delete(`${resource}/${params.id}`),
    [DELETE_MANY]: (resource, params) =>
      Promise.all(params.ids.map(id => httpClient.delete(`${resource}/${id}`))).then(() => Promise.resolve()),
  };
};
